<script setup lang="ts">
import { useNavigationStore } from '@/stores/navigationStore';
import ProgressBar from 'primevue/progressbar';

const navigationStore = useNavigationStore();
</script>

<template>
    <ProgressBar v-if="navigationStore.istNavigationAktiv" mode="indeterminate" class="fixed top-0 left-0 w-full z-[1100] !h-1" />
    <router-view />
</template>

<style scoped></style>
